
'use strict';

const FIELD_TITLES = {
    sku: 'SKU',
    title: 'Title',
    price: 'Unit Price',
    msrp: 'MSRP',
    description: 'Description',
    variants: 'Variations'
};

const ORDER_SHEET_TEMPLATE = `
<style type="text/css" scoped>
[FONTS/]
.page {
    background-color: [BACKGROUND_COLOR/];
    color: [TEXT_DEFAULT_COLOR/];
    font-family: [TEXT_DEFAULT_FONT_FAMILY/];
    font-size: [TEXT_DEFAULT_FONT_SIZE/];
}
.title {
    font-size: 3em;
    color: [ACCENT_COLOR/];
    font-family: [TITLE_FONT_FAMILY/];
}
.product-image {
    background-size: [IMAGE_SIZE/];
    background-repeat: no-repeat; 
    background-position: center center;
    height: 100%;
    width: 100%;
}
.header, .footer {
    font-size: 1.5em;
}
.price {
    font-size: 2em;
}
.table {
    width: 100%;
    display: table;
}
.table-header {
    display: table-header-group;
    font-weight: bold;
}
.table-cell-price {
    text-align: right;
}
.table-body {
    display: table-row-group;
}
.table-row  {
    display: table-row;
    height: [TABLE_CELL_HEIGHT/];
}

.table-body > .table-row:nth-child(odd) {
    background: #f6f6f6;
}

.table-cell {
    display: table-cell;
    vertical-align: middle;
}
</style>

<div class="page" style="
position: relative; 
font-size: 5pt;
width: 612px; 
height: 792px; ">
    <div class="page-content" style="position: absolute; top: 32px; left: 54px; right: 54px; bottom: 32px">
        <div class="header" style="position: absolute; top: 0; left: 0; width: 100%; height: 50px;">
            <div style="width: 20%; height: 100%; float: left">
            </div>
            <div style="width: 60%; height: 100%; float: left; line-height: 50px; text-align: center">
            [TITLE/]
            </div>
        </div>
        <div style="width: 100%;  height: 624px; top: 72px;  position: absolute;">
            [PRODUCTS_TABLE/]
        </div>
        <div class="footer" style="position: absolute; bottom: 0; left: 0; width: 100%; height: 25px;">
            <div style="width: 5%; height: 100%; position: absolute; left: 0;">
                [FOOTER_LOGO/]
            </div>
            <div style="width: 100%; height: 100%; text-align: center; position: absolute; right: 0; line-height: 25px; white-space:nowrap;">[FOOTER_NAME/] [FOOTER_WEBSITE/] [FOOTER_ADDRESS/] [FOOTER_PHONE_NUMBER/] [FOOTER_CONTACT_EMAIL/]</div>
            <div style="width: 5%; height: 100%;  position: absolute; right: 0;">

            </div>
        </div>
    </div>
    `
exports.ORDER_SHEET_TEMPLATE = ORDER_SHEET_TEMPLATE;

function buildFontText(font) {
    if (font && font.files && font.files[font.style]) {
        return `@font-face {
            font-family: '${font.family}';
            src: url(${font.files[font.style]});
        }`;
    }
    return '';
}

function checkField(fields, field, returnValue) {
    return fields.indexOf(field) > -1 ? (returnValue || '') : '';
}

function formatMoney(price, precision, decimalSeparator, hundredsSeparator) {
    var precision = isNaN(precision = Math.abs(precision)) ? 2 : precision,
      decimalSeparator = decimalSeparator == undefined ? "." : decimalSeparator,
      hundredsSeparator = hundredsSeparator == undefined ? "," : hundredsSeparator,
      s = price < 0 ? "-" : "",
      i = String(parseInt(price = Math.abs(Number(price) || 0).toFixed(precision))),
      j = (j = i.length) > 3 ? j % 3 : 0;
  
    return s + (j ? i.substr(0, j) + hundredsSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + hundredsSeparator) + (precision ? decimalSeparator + Math.abs(price - i).toFixed(precision).slice(2) : "");
  };

exports.buildOrderSheet = function (template, user, catalog) {
    console.log('build order sheet')
    var preview;
    var orderSheet = user.order_sheet_configuration;
    if (!orderSheet.background_color) {//not initialized
        orderSheet.background_color = '#ffffff';
        orderSheet.header_fields = ['logo']
        orderSheet.footer_fields = ['name', 'address', 'phone_number', 'contact_email']    
        orderSheet.title_font = {
            family: 'Open Sans',
            size: '11px',
            style: 'regular'
        };
        orderSheet.text_default_font = {
            family: 'Open Sans',
            size: '24px',
            style: 'regular'
        };
        orderSheet.product_fields = ['title', 'price', 'sku'];
        orderSheet.images_size = 'contain';
        orderSheet.accent_color = '#0e78d2';
        orderSheet.text_default_color = '#000000';
    }

    var headerFields = orderSheet.header_fields;
    var footerFields = orderSheet.footer_fields;
    var productFields = orderSheet.product_fields;
    var businessProfile = user.business_profile;
    var pagesElements = [];
    catalog.pages.forEach(page => {
        var pageTitle = page.header.properties.html;
        var pageIndex = 0;
        page.elements.forEach(element => {
            if (element.type === 'application/product') {
                if (pageIndex >= pagesElements.length) {
                    pagesElements.push({title: pageTitle, elements: []});
                }
                if (pagesElements) {
                    pagesElements[pageIndex].elements.push(element);
                }
                if (pagesElements[pageIndex].elements.length >= orderSheet.max_products_per_page-1) {
                    pageIndex += 1;
                }
            }
        });
    });
    
    let rowHeight = (624/(orderSheet.max_products_per_page+1)) + 'px';
    let content = {
        //header
        HEADER_LOGO: checkField(headerFields, 'logo', businessProfile.logo_url ? `<img src="${businessProfile.logo_url}" style="height: 100%">` : ''),
        HEADER_NAME: checkField(headerFields, 'name', businessProfile.name),
        HEADER_WEBSITE: checkField(headerFields, 'website', businessProfile.website),
        HEADER_ADDRESS: checkField(headerFields, 'address', businessProfile.address),
        HEADER_PHONE_NUMBER: checkField(headerFields, 'phone_number', businessProfile.phone_number),
        HEADER_CONTACT_EMAIL: checkField(headerFields, 'contact_email', businessProfile.contact_email),
 
        //footer
        FOOTER_LOGO: checkField(footerFields, 'logo', businessProfile.logo_url ? `<img src="${businessProfile.logo_url}" style="height: 100%">` : ''),
        FOOTER_NAME: checkField(footerFields, 'name', businessProfile.name),
        FOOTER_WEBSITE: checkField(footerFields, 'website', businessProfile.website),
        FOOTER_ADDRESS: checkField(footerFields, 'address', businessProfile.address),
        FOOTER_PHONE_NUMBER: checkField(footerFields, 'phone_number', businessProfile.phone_number),
        FOOTER_CONTACT_EMAIL: checkField(footerFields, 'contact_email', businessProfile.contact_email),

        //style
        FONTS: buildFontText(orderSheet.text_default_font) + buildFontText(orderSheet.title_font),
        IMAGE_SIZE: orderSheet.images_size,
        BACKGROUND_COLOR: orderSheet.background_color,
        TEXT_DEFAULT_COLOR: orderSheet.text_default_color,
        TEXT_DEFAULT_FONT_SIZE: orderSheet.text_default_font.size,
        TEXT_DEFAULT_FONT_FAMILY: orderSheet.text_default_font.family,
        TITLE_FONT_SIZE: orderSheet.title_font.size,
        TITLE_FONT_FAMILY: orderSheet.title_font.family,
        ACCENT_COLOR: orderSheet.accent_color,

        TABLE_CELL_HEIGHT: rowHeight
    };

    
    if (pagesElements.length > 0) {
        var pageElements = pagesElements[0];
        console.log(pageElements.title)
        content.TITLE = pageElements.title;
        var productTable = '<div class="table">';
        productTable += '<div class="table-header">';
        productTable += '<div class="table-row">';
        productTable += `<div class="table-cell">&nbsp;</div>`;
        productFields.forEach(field => {
            productTable += `<div class="table-cell">${FIELD_TITLES[field]}</div>`;
        });
        productTable += `<div class="table-cell">Quantity</div>`;
        productTable += `<div class="table-cell">Total</div>`;
        productTable += '</div>';
        productTable += '</div>';
        productTable += '<div class="table-body">';
        pageElements.elements.forEach(element => {
            var properties = Object.assign({}, element.properties);
            var variations = '';
            properties.variations.forEach((variation) => {
                let options = variation.options;
                variations += options.join(', ') + '<br/>';
            });
            properties.variations = variations;
            productTable += '<div class="table-row">';
            productTable += `<div class="table-cell table-cell-image">
                    <div class="product-image" style="background-image: url('${properties.compressed_image || properties.main_image}'); height: ${rowHeight}; width: 42px"></div>
                </div>`;
            productFields.forEach(field => {
                var value = properties[field];
                if (field === 'price') {
                    value = businessProfile.money_format.replace('{{amount}}', '' + formatMoney(properties.price));
                }
                productTable += `<div class="table-cell table-cell-${field}">${value}</div>`;      
            });      
            productTable += '<div class="table-cell"></div>';  
            productTable += '<div class="table-cell"></div>';  
            productTable += '</div>';
        });
        productTable += '</div>';
        productTable += '</div>';
        content.PRODUCTS_TABLE = productTable;
        preview = ORDER_SHEET_TEMPLATE;
        for (let key in content) {
            var regex = `\\[${key}\\](.*)\\?(.*)\\[/${key}\\]`;
            var re = new RegExp(regex, 'g');
            preview = preview.replace(re, content[key] ? `$1${content[key]}$2` : '');

            preview = preview.replace(`[${key}/]`, content[key]);
        }
    }
    return preview;
};
